// debug 用于本地调试
import URL from '../utils/url'; // 根据url 是否同时包含 _debug 和 _app 参数， 且 _app 参数为数字

var DEBUGQUERY_STR = '_debug';
var DEBUGSELLCHANNEL_STR = '_app';
var debug = URL.getQuery(DEBUGQUERY_STR);
var sellChannel = URL.getQuery(DEBUGSELLCHANNEL_STR);
var IS_DEBUG = debug !== undefined && !!+sellChannel;
export default {
  IS_DEBUG: IS_DEBUG,
  DEBUG_SELLCHANNEL: +sellChannel || 0
};